import { post } from "./api"

export const createSupportTicket = (params) => {
  return post("/notifications/ticket-support", params, {
    headers: { "Content-Type": "multipart/form-data" },
  })
}
